import { useState } from 'react';
import copy from 'copy-to-clipboard';

import classNames from 'classnames';
import { CopyIcon } from 'components/Icons';

import StyledCopyButton from './styles';

const RESET_TIMEOUT = 2000;

const CopyButton = ({
    text,
    noText,
}) => {
    const [isCopied, setCopied] = useState(false);

    const copyContactAddress = (e) => {
        e.stopPropagation();
        copy(text);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, RESET_TIMEOUT);
    };

    return (
        <StyledCopyButton
            className="copy-button btn-link with-icon"
            onClick={copyContactAddress}
        >
            <CopyIcon color={isCopied ? 'var(--black)' : 'var(--brand)'} />
            {!noText && (
                <span
                    className={classNames('copy-button--label', { copied: isCopied })}
                >
                    {!isCopied
                        ? <span>Copy</span>
                        : <span>Copied!</span>}

                </span>
            )}
        </StyledCopyButton>
    );
};

CopyButton.defaultProps = {
    noText: false,
};

export default CopyButton;
